// extracted by mini-css-extract-plugin
export default {"random-selection":"Random_random-selection__L4xgc","random-btn":"Random_random-btn__obo-C","svg":"Random_svg__WtH9V","select-category":"Random_select-category__dJFU8"};